import Vue from 'vue';

const BLOG_API = (process.env.NODE_ENV === 'production') ? process.env.VUE_APP_BLOG_API : '/blog/';

const state = () => ({
  categories: {
    timestamp: null,
    items: [],
  },
  featured: {
    timestamp: null,
    items: [],
  },
  recent: {
    timestamp: null,
    items: [],
  },
});

const mutations = {
  SET_CATEGORIES(state, payload) {
    state.categories = payload;
  },

  SET_FEATURED_NEWS(state, payload) {
    state.featured = payload;
  },

  SET_RECENT_NEWS(state, payload) {
    state.recent = payload;
  },
};

const actions = {
  async getCategories({ commit }) {
    const { data: items } = await Vue.axios.get(`${BLOG_API}categories?per_page=16`);
    const timestamp = Vue.prototype.$day().unix();
    commit('SET_CATEGORIES', { timestamp, items });
  },

  async getFeatured({ commit }, options) {
    const { size, params } = options;

    const { data } = await Vue.axios.get(`${BLOG_API}posts${params}`);

    const items = data.map((item) => ({
      id: item.id,
      url: item.link,
      title: item.title.rendered,
      // eslint-disable-next-line no-underscore-dangle
      image: item._embedded['wp:featuredmedia'][0].media_details.sizes[size].source_url || '',
    }));

    const timestamp = Vue.prototype.$day().unix();
    commit('SET_FEATURED_NEWS', { timestamp, items });
  },

  async getRecent({ commit, state }, options) {
    const { categories, params } = options;

    const selectedCategories = state.categories.items
      .filter((cat) => categories.includes(cat.slug))
      .map((cat) => ({
        id: cat.id,
        name: cat.name,
        link: cat.link,
      }));

    const fetchPost = async (category) => {
      const { data } = await Vue.axios.get(`${BLOG_API}posts${params}&categories=${category}`);
      return data.map((item) => ({
        id: item.id,
        url: item.link,
        title: item.title.rendered,
        published: item.date,
        // eslint-disable-next-line no-underscore-dangle
        image: item._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url || '',
      }));
    };

    const fetchPostCategory = async (category) => ({ ...category, posts: await fetchPost(category.id) });
    const items = await Promise.all(selectedCategories.map(async (category) => fetchPostCategory(category)));
    const timestamp = Vue.prototype.$day().unix();

    commit('SET_RECENT_NEWS', { timestamp, items });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
